import React from "react";
import ServiceSection1 from "../component/servicedetails/ServiseSection1";
import FormFooter from "../component/FormFooter";
import Header from "../component/Header";

function ServicePage(){
    return(
        <>
        <Header/>
        <ServiceSection1/>
        <FormFooter/>
        </>
    );
}
export default ServicePage;